// extracted by mini-css-extract-plugin
module.exports = {"layout":"jJ8OsoLeouLinK6cRxoRpA=="};